import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import "@/core/plugins/prismjs";
const app = createApp(App);

/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
Sentry.init({
  app,
  dsn: "https://9bff5de33f4f429ebd57e29f67c82382@svr221.street-directory.com.au:9001/19",
  tunnel: `${process.env.VUE_APP_API_URL}/sentry`,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        /^\//,
      ],
    }),
  ],
  tracesSampleRate: 1,
  release: process.env.NODE_ENV,
});

app.use(store);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.component('VueDatePicker', VueDatePicker);

app.mount("#app");
